export const en = {
  nav: {
    home: "Home",
    finances: "Finances",
    wallets: "Wallets",
    countriesAndCurrencies: "Countries & Currencies",
    deposits: "Deposits",
    withdrawals: "Withdrawals",
    conversionsAndReservations: "Conversions & Reserves",
    virtualCards: "Virtual Cards",
    accounts: "Accounts",
    transactions: "Transactions",
    history: "History",
    pending: "Pending",
    paymentLinks: "Payment Links",
    team: "Team",
    developers: "Developers",
    appsAndWebhooks: "Apps & Webhooks",
    apiDocumentation: "API Documentation",
    verification: "Verification",
    settings: "Settings",
    notifications: "Notifications",
    assistant: "Agent",
    support: "Help",
    supportAdmin: "Support management",
    help: "Help",
    logout: "Log out",
  },
  common: {
    save: "Save",
    saving: "Saving…",
    cancel: "Cancel",
    confirm: "Confirm",
    delete: "Delete",
    edit: "Edit",
    create: "Create",
    upload: "Upload",
    send: "Send",
    download: "Download",
    copy: "Copy",
    copied: "Copied!",
    retry: "Retry",
    loading: "Loading…",
    search: "Search",
    filter: "Filter",
    all: "All",
    close: "Close",
    viewAll: "View all",
    details: "Details",
    actions: "Actions",
    back: "Back",
    next: "Next",
    previous: "Previous",
    refresh: "Refresh",
    status: "Status",
    date: "Date",
    amount: "Amount",
    currency: "Currency",
    country: "Country",
    reference: "Reference",
    type: "Type",
    recipient: "Recipient",
    unknown: "Unknown",
    empty: "No items found",
    success: "Operation successful",
    error: "An error occurred",
    active: "Active",
    inactive: "Inactive",
    enabled: "Enabled",
    disabled: "Disabled",
    na: "—",
  },
  operations: {
    DEPOSIT: "Deposit",
    PAYIN: "Collection",
    PAYOUT: "Payout",
    REFUND: "Refund",
    TRANSFER_IN: "Transfer received",
    TRANSFER_OUT: "Transfer sent",
    WITHDRAWAL: "Withdrawal",
    TRANSFER: "Transfer",
    NOTIFICATION_PLAN_SUBSCRIPTION: "Notification plan subscription",
  },
  statuses: {
    COMPLETED: "Completed",
    FAILED: "Failed",
    PENDING: "Pending",
    PROCESSING: "Processing",
    ACTIVE: "Active",
    SUSPENDED: "Suspended",
    CLOSED: "Closed",
    APPROVED: "Approved",
    REJECTED: "Rejected",
    SUBMITTED: "Submitted",
    UNDER_REVIEW: "Under review",
    DRAFT: "Draft",
  },
  methods: {
    card: "Credit / Debit Card",
    internal: "Internal Transfer",
    mobile_money: "Mobile Money",
    mtn: "MTN Mobile Money",
    orange: "Orange Money",
    wave: "Wave",
  },
  topbar: {
    searchPlaceholder: "Search transactions (reference, counterparty)…",
    notifications: "Notifications",
    markAllRead: "View all",
    noNotifications: "No notifications",
    help: "Help",
    helpTitle: "Help Center",
    helpDesc:
      "Browse API documentation or reach out to BizConnectPay support for integration guidance.",
    accountMenu: "Account menu",
    accountDefault: "BizConnectPay Account",
    settings: "Settings",
    logout: "Log out",
    language: "Language",
  },
  overview: {
    title: "Home",
    subWelcome: "Welcome, {name} · {space}",
    businessSpace: "Business workspace",
    individualSpace: "Individual account",
    deposit: "Deposit",
    withdraw: "Withdraw",
    transfer: "Transfer",
    loadingOverview: "Loading overview…",
    paymentOverview: "Payment Overview",
    periodSub: "Completed transactions over selected period",
    transactions: "Transactions",
    transactionsHint: "Total count of executed and settled payments",
    totalVolume: "Total Volume",
    totalVolumeHint: "Sum of processed and converted payments volume",
    activeMarkets: "Active Markets",
    activeMarketsHint: "Countries where transactions successfully settled",
    balancesAndWallets: "Balances & Wallets",
    walletsSub: "Available funds by country and currency",
    allWallets: "Manage wallets",
    recentTransactions: "Recent Transactions",
    recentSub: "Latest processed payments",
    allTransactions: "All transactions",
    emptyTxs: "No transactions recorded yet.",
    complianceBannerTitle: "Account Verification ({type})",
    compliancePending:
      "Your file is being assembled. Please submit your supporting documents.",
    complianceUnderReview:
      "Your file has been submitted and is currently being reviewed by compliance.",
    complianceApproved: "Your account is fully verified and unrestricted.",
    goToVerification: "Open verification",
    quickActions: "Quick Actions",
  },
  wallets: {
    title: "Wallets",
    sub: "Manage your local and international currency balances.",
    countriesAndNewWallet: "Countries & new wallet",
    filterCurrency: "Filter by currency",
    filterStatus: "Filter by status",
    allCurrencies: "All currencies",
    allStatuses: "All statuses",
    refreshWallets: "Refresh wallets",
    emptyWallets:
      "No wallets match your filters. Your primary country wallet is automatically provisioned by BizConnectPay at signup.",
    availableBalance: "Available Balance",
    totalBalance: "Total Balance",
    walletType: "Wallet Type",
    scope: "Scope",
    local: "Local",
    international: "International",
    deposit: "Deposit",
    withdraw: "Withdraw",
    transfer: "Transfer",
    transactionsForWallet: "Transactions for this wallet",
    emptyWalletTxs: "No transactions found for this wallet.",
    catalogTitle: "Supported countries & new wallet opening",
    catalogSub: "Explore supported currencies and open an additional wallet.",
    openWalletBtn: "Open a wallet",
    openWalletSuccess: "New wallet opened successfully!",
  },
  transactions: {
    title: "Transactions",
    sub: "Comprehensive history of your financial operations and payouts.",
    exportCsv: "Export CSV",
    filterAll: "{label}: all",
    searchPlaceholder: "Filter by reference, counterparty, description…",
    allCurrencies: "All currencies",
    allStatuses: "All statuses",
    allOperations: "All operations",
    emptyTransactions: "No transactions match your current filters.",
    referenceCol: "Reference",
    typeCol: "Type",
    amountCol: "Amount",
    feeCol: "Fee",
    statusCol: "Status",
    dateCol: "Date",
    detailsBtn: "View",
  },
  verification: {
    title: "Verification & Compliance",
    subKyb: "Business Verification (KYB) · Supporting documents & records",
    subKyc: "Identity Verification (KYC) · Personal identity documents",
    rulesTitle: "Compliance Rules for Approval",
    requiredDocsTitle: "Required documents for your account",
    doneOf: "{done} of {total} documents submitted according to server",
    serverList: "List provided by server",
    selectedCount: "{count} document(s) selected",
    selectedBatchDesc:
      "You can upload all selected documents in a single action.",
    uploadAll: "Upload all ({count})",
    uploadingBatch: "Uploading {current}/{total}…",
    noRequirements: "No requirements found",
    noRequirementsSub:
      "The server did not return required documents for this case.",
    missingDocs: "Missing documents: {list}",
    addExtraDocTitle: "Add another document",
    addExtraDocSub: "Direct upload for {type} case",
    categoryLabel: "Category",
    chooseCategory: "Choose category",
    fileLabel: "File (PDF, JPG, PNG)",
    noDocsSaved: "No documents uploaded yet",
    noDocsSavedSub: "Submitted documents will be displayed here.",
    viewMetadata: "View metadata",
    contractTitle: "Merchant Service Agreement",
    contractSub: "Download the agreement, sign it, and upload the signed PDF.",
    noContract: "No contract issued yet",
    noContractSub:
      "The contract will appear here once generated for your business account.",
    consultContract: "View",
    downloadContract: "Download agreement",
    uploadSigned: "Upload signed copy",
    caseStatusTitle: "Case Status",
    businessAccount: "Business Account",
    individualAccount: "Individual Account",
    statusApproved:
      "Your case is approved. All payment processing features are fully active.",
    statusInReview:
      "Your file has been submitted and is currently under review by our compliance team.",
    statusPending:
      "Your file is being assembled. Please upload all required documents before submitting.",
    lockedWarning:
      "Collections and payouts remain restricted until full case approval.",
    finalSubmission: "Final Submission",
    completeTitle: "Case complete",
    completeDesc:
      "All required documents have been uploaded. You can now submit your file for review.",
    incompleteDesc:
      "Upload all required documents on the left before submitting your file.",
    submitButton: "Submit case",
    alreadySubmitted: "Case already submitted",
    confirmTitle: "Submit {type} case?",
    confirmDesc:
      "Once submitted, the case will transition to UNDER_REVIEW status and cannot be edited while being reviewed by compliance.",
    confirmButton: "Confirm submission",
    metadataTitle: "Document Metadata",
    openCaseTitle: "Open a verification case",
    openCaseSub:
      "The case type ({type}) is determined by the server based on your active account.",
    caseLanguage: "Case language",
    createCaseButton: "Create case",
    chooseFileFirst: "Please select a file first.",
    chooseCategoryAndFile: "Please select both a category and a file.",
    uploadSuccess: "Document {category} uploaded successfully.",
    batchSuccess: "{count} document(s) uploaded successfully!",
    batchError: "Error while uploading some documents.",
    signedUploadSuccess: "Signed contract uploaded successfully.",
    submitSuccess:
      "Verification case submitted successfully! It is currently under review.",
    categories: {
      IDENTITY_DOCUMENT: {
        label: "Official Identity Document",
        desc: "National ID Card (both sides), Valid Passport, or Residence Permit.",
      },
      IDENTITY_RECEIPT: {
        label: "Identity application receipt",
        desc: "Official receipt for a national identity card application.",
      },
      ELECTION_CARD: {
        label: "Voter card",
        desc: "Official, valid and legible voter card.",
      },
      NATIONAL_ID: {
        label: "National identity card",
        desc: "Valid national identity card, front and back.",
      },
      CNI: {
        label: "National identity card",
        desc: "Valid national identity card, front and back.",
      },
      PASSPORT: {
        label: "Passport",
        desc: "Valid passport.",
      },
      DRIVER_LICENSE: {
        label: "Driver's license",
        desc: "Official, valid driver's license.",
      },
      SELFIE_WITH_ID: {
        label: "Selfie with ID Document",
        desc: "Clear photo of your face holding the ID document visibly and legibly.",
      },
      ADDRESS_PROOF: {
        label: "Recent Proof of Address",
        desc: "Utility bill (water/electricity), rental receipt, or residency certificate (< 3 months old).",
      },
      BUSINESS_ADDRESS_PROOF: {
        label: "Business Address Proof",
        desc: "Commercial lease agreement, rent receipt, or recent utility bill in the company name.",
      },
      PROOF_OF_BUSINESS_ADDRESS: {
        label: "Business Address Proof",
        desc: "Commercial lease agreement or utility bill in the company name.",
      },
      BENEFICIAL_OWNER_LIST: {
        label: "Beneficial Owner List",
        desc: "Official certified list declaring all shareholders/owners holding 25% or more capital or voting rights.",
      },
      BUSINESS_REGISTRATION: {
        label: "Business Registration (RCCM)",
        desc: "Trade Register certificate (RCCM) or official certificate of incorporation.",
      },
      REGISTRATION_CERTIFICATE: {
        label: "Business Registration (RCCM)",
        desc: "Trade register extract or official company registration certificate.",
      },
      BUSINESS_TAX_CERTIFICATE: {
        label: "Tax Identification Certificate (NIF)",
        desc: "Official Tax ID certificate (NIF), tax clearance certificate, or valid taxpayer card.",
      },
      TAX_IDENTIFICATION_DOCUMENT: {
        label: "Tax Identification Number (NIF)",
        desc: "Official tax registration certificate or active taxpayer card.",
      },
      TAX_CLEARANCE: {
        label: "Tax Clearance Certificate",
        desc: "Official certificate of non-indebtedness issued by the tax authorities.",
      },
      ARTICLES_OF_INCORPORATION: {
        label: "Articles of Incorporation",
        desc: "Signed and registered company bylaws or official notarized deed.",
      },
      BANK_STATEMENT: {
        label: "Bank Account Details (RIB)",
        desc: "Professional bank statement or certificate under the legal business name.",
      },
      REPRESENTATIVE_ID: {
        label: "Legal Representative ID",
        desc: "National ID or passport of the manager or director listed in the bylaws.",
      },
      POWER_OF_ATTORNEY: {
        label: "Power of Attorney / Mandate",
        desc: "Notarized power of attorney or board resolution authorizing the representative.",
      },
      SIGNED_BUSINESS_CONTRACT: {
        label: "Signed Business Agreement",
        desc: "BizConnectPay service agreement initialed, signed, and stamped by the legal representative.",
      },
      SIGNED_CONTRACT: {
        label: "Signed Business Agreement",
        desc: "BizConnectPay service agreement initialed, signed, and stamped by the legal representative.",
      },
      FINANCIAL_STATEMENTS: {
        label: "Certified Financial Statements",
        desc: "Audited balance sheet or income statement for the last closed fiscal year.",
      },
      SHAREHOLDER_REGISTER: {
        label: "Shareholder / Member Register",
        desc: "Official register of shares and members certified by company management.",
      },
    },
    statuses: {
      NOT_STARTED: "NOT STARTED",
      PENDING: "PENDING",
      UNDER_REVIEW: "UNDER REVIEW",
      IN_REVIEW: "UNDER REVIEW",
      SUBMITTED: "SUBMITTED",
      APPROVED: "APPROVED",
      REJECTED: "REJECTED",
      MORE_INFORMATION_REQUIRED: "MORE INFO REQUIRED",
      SIGNED_RECEIVED: "SIGNED CONTRACT RECEIVED",
      DRAFT: "DRAFT",
      ACTIVE: "ACTIVE",
      UPLOADED: "UPLOADED",
    },
    contractStatuses: {
      PENDING: "AWAITING SIGNATURE",
      SIGNED_RECEIVED: "SIGNED CONTRACT RECEIVED",
      SIGNED: "SIGNED",
      APPROVED: "APPROVED",
      REJECTED: "REJECTED",
      DRAFT: "DRAFT",
      ACTIVE: "ACTIVE",
    },
    rules: {
      "Company information must match official registration records.":
        "Company information must match official registration records.",
      "Every beneficial owner must be declared.":
        "Every beneficial owner holding at least 25% equity must be declared.",
      "All submitted documents must be valid and readable.":
        "All submitted documents must be valid, readable, and unexpired.",
      "The authorized representative must sign and return the BizConnectPay service agreement.":
        "The authorized representative must sign and upload the BizConnectPay service agreement.",
      "Documents must be valid, readable, and unexpired.":
        "Documents must be valid, readable, and unexpired.",
      "The account holder name must match the identity document.":
        "The account holder name must match the identity document.",
      "Proof of address must be recent.":
        "Proof of address must be recent (less than 3 months old).",
    },
  },
  settings: {
    title: "Settings",
    sub: "Account profile, display language, notification preferences, and transaction fees.",
    tabProfile: "Profile & Language",
    tabNotifications: "Notification Preferences",
    tabFees: "Fees & Pricing",
    profileTitle: "Profile",
    fullName: "Full name",
    email: "Email",
    emailLockedHint: "Email address is locked and cannot be edited.",
    phone: "Phone number",
    saveProfileBtn: "Save profile",
    profileSavedToast: "Profile saved successfully",
    notificationsTitle: "Notification Preferences",
    notificationsSub:
      "Configure delivery channels for security and transaction alerts.",
    channelEmail: "Email",
    channelSms: "SMS",
    channelPush: "Browser",
    channelInApp: "In-app",
    channelWhatsApp: "WhatsApp",
    channelEmailSub: "Alerts sent to your email address",
    channelSmsSub: "Alerts sent via SMS",
    channelPushSub: "Notifications inside the dashboard",
    channelInAppSub: "Notifications visible in your workspace",
    channelWhatsAppSub: "Alerts sent to your WhatsApp number",
    eventPaymentCompleted: "Payment completed",
    eventKycApproved: "KYC approved",
    eventKybApproved: "KYB approved",
    prefSavedToast: "Preference saved",
    languageSectionTitle: "Display Language",
    languageSectionSub:
      "Choose your preferred language for navigating the merchant console.",
    feesTitle: "COLLECTION & DISTRIBUTION Fees",
    feesSub:
      "View the fixed rates applied to your collections (deposits / payment links) and distributions (withdrawals / payouts) and simulate your transactions.",
    collectionFeeTitle: "Collection (COLLECTION / Deposit)",
    collectionFeeDesc:
      "Applied to payment links, deposits, and API payments (/v1/payments). You can choose whether the fee is borne by the merchant or charged to the customer.",
    distributionFeeTitle: "Distribution (DISTRIBUTION / Withdrawal)",
    distributionFeeDesc:
      "Mode B: The beneficiary receives the exact requested amount and the fee is added to your wallet debit.",
    internalTransferFeeTitle: "Internal Transfer (BCP to BCP)",
    internalTransferFeeDesc:
      "Instant transfers between BizConnectPay accounts.",
    feeSimulatorTitle: "Real-Time Fee Simulator",
    feeSimulatorSub:
      "Simulate the amount charged to the customer, BizConnectPay fees, and the net amount credited or debited on your wallet.",
    simOperation: "Operation type",
    simOperationCollection: "Collection (COLLECTION / Deposit)",
    simOperationDistribution: "Distribution (DISTRIBUTION / Withdrawal)",
    simAmount: "Base amount",
    simCurrency: "Currency",
    simFeePayer: "Who pays the fee?",
    simPayerMerchant: "Merchant (deducted from amount)",
    simPayerCustomer: "Customer (added to payable amount)",
    simCustomerPays: "Amount charged to customer",
    simFeeAmount: "BizConnectPay fee",
    simMerchantNet: "Credited to merchant wallet",
    simBeneficiaryReceives: "Received by beneficiary",
    simWalletTotalDebit: "Total debited from merchant wallet",
    feePayerLabel: "Collection fee bearer",
    feePayerMerchantOption: "Merchant — Fee deducted from received amount",
    feePayerCustomerOption: "Customer — Fee added to customer payment request",
    feePayerSavedToast: "Fee bearer preference updated",
    tabSecurity: "Security & 2FA",
    channelComingSoon: "Coming soon",
    channelComingSoonTooltip:
      "This channel is not yet enabled on the platform.",
    twoFactorTitle: "Two-Factor Authentication (2FA)",
    twoFactorSub:
      "Protect access to your merchant account with a one-time security code (OTP).",
    twoFactorStatus: "2FA Status",
    twoFactorEnabled: "Enabled",
    twoFactorDisabled: "Disabled",
    twoFactorActiveChannel: "Active channel",
    twoFactorChannelSelect: "Select channel to receive your OTP code",
    twoFactorChannelEmail: "Email (Recommended)",
    twoFactorChannelSms: "SMS (Phone)",
    twoFactorChannelWhatsApp: "WhatsApp",
    twoFactorSendOtpBtn: "Send OTP code",
    twoFactorSending: "Sending…",
    twoFactorOtpLabel: "Verification code (6 digits)",
    twoFactorOtpPlaceholder: "E.g. 123456",
    twoFactorConfirmBtn: "Verify and Enable 2FA",
    twoFactorDisableBtn: "Disable 2FA",
    twoFactorDisableConfirm:
      "Are you sure you want to disable two-factor authentication?",
    twoFactorRecoveryTitle: "Recovery Codes (Important)",
    twoFactorRecoverySub:
      "Save these recovery codes in a safe place. Each code can only be used once if you lose access to your 2FA channel.",
    twoFactorRecoveryClose: "I have saved my codes",
    twoFactorSuccessToast: "Two-factor authentication successfully enabled!",
    twoFactorDisabledToast: "Two-factor authentication disabled.",
  },
  auth: {
    twoFactorTitle: "Two-Factor Authentication (2FA)",
    twoFactorSub:
      "A 6-digit security code has been sent via {channel} to {destination}.",
    twoFactorCodeLabel: "Security code (6 digits or recovery code)",
    twoFactorPlaceholder: "123456",
    twoFactorResendBtn: "Resend code",
    twoFactorResending: "Resending…",
    twoFactorResentToast: "New code sent successfully!",
    twoFactorVerifyBtn: "Verify and Sign In",
    twoFactorBackBtn: "Back to sign in",
    loginBadge: "Secure Merchant Portal",
    loginHeroTitle:
      "Collect, disburse and monitor your operations from a single dashboard.",
    loginHeroSub:
      "Access your BizConnectPay wallets, transactions, compliance files, and API credentials.",
    loginHeroFooter: "© 2026 BizConnectPay. End-to-end encrypted connection.",
    loginCategory: "Merchant Sign In",
    loginWelcome: "Welcome",
    loginSub: "Sign in to your BizConnectPay merchant space.",
    emailLabel: "Email address",
    emailPlaceholder: "name@company.com",
    passwordLabel: "Password",
    passwordPlaceholder: "••••••••",
    accountIdOptional: "Account ID (optional)",
    accountTypeOptional: "Workspace type (optional)",
    workspaceBusiness: "Business Workspace",
    workspaceIndividual: "Individual Account",
    defaultWorkspace: "Default workspace",
    signInBtn: "Sign in",
    signingIn: "Signing in…",
    noAccount: "New to BizConnectPay?",
    registerLink: "Create an account",
    forgotPasswordLink: "Forgot password?",
    resendVerificationLink: "Resend verification email",
    orDivider: "or",
    registerBadge: "Account Opening",
    registerHeroTitle:
      "The unified payment gateway for Africa and international markets.",
    registerHeroSub:
      "Integrate Orange Money, MTN, Wave, bank cards and wire transfers with a single API.",
    registerCategory: "New Merchant Account",
    registerTitle: "Create your account",
    registerSub: "Fill in your details to start your integration.",
    businessType: "Business / Company",
    individualType: "Individual / Professional",
    registerHeroCompliance:
      "© 2026 BizConnectPay. Compliant with banking and CEMAC/UEMOA standards.",
    accountTypeLabel: "Account Type",
    businessKyb: "Business (KYB)",
    businessKybDesc: "Corporations, LLCs, Entities",
    individualKyc: "Individual (KYC)",
    individualKycDesc: "Freelancers & Sole proprietors",
    operatingCountry: "Country of operation",
    countryHelp:
      "Payment method availability depends on the BizConnectPay catalog.",
    phoneHelp:
      "Enter number without dial code. Changing country clears number.",
    matriculeLabel: "Your unique and permanent account ID:",
    verifyEmailNotice:
      "A verification email has been sent to {email}. Open the link to confirm your address.",
    kybPendingNotice:
      "Your account is pending {type} verification: financial operations are not yet enabled.",
    resendSuccess: "Request sent.",
    resendFailed: "Failed to send, please try again.",
    creatingAccount: "Creating account…",
    businessNameLabel: "Company Name",
    individualNameLabel: "Trade / Display Name",
    createAccountBtn: "Create my account",
    alreadyRegistered: "Already have an account?",
    signInLink: "Sign in",
    registrationSuccessTitle: "Account created successfully!",
    registrationSuccessSub:
      "Please check your email address to activate your account.",
  },
  cards: {
    title: "Virtual Cards",
    sub: "Issue prepaid Visa and Mastercard virtual cards for company expenses.",
    subBlocked: "Virtual card issuance and management.",
    subSensitive:
      "Sensitive card details are never permanently stored by BizConnectPay.",
    unavailableTitle: "Cards unavailable",
    unavailableSub:
      "Your account is not yet authorized for financial operations. Please complete KYC.",
    createCard: "New Card",
    cardholderBtn: "Cardholder",
    issueCardBtn: "Issue a card",
    cardsPanel: "Cards",
    cardholdersPanel: "Cardholders",
    emptyCards: "No cards",
    emptyCardsSub: "Create a cardholder, then issue your first card.",
    emptyHolders: "No cardholders",
    emptyHoldersSub: "A cardholder is required before any card issuance.",
    openCardBtn: "Open",
    cardFallback: "Card",
    freezeCard: "Freeze Card",
    unfreezeCard: "Unfreeze Card",
    cardHolder: "Cardholder",
    cardNumber: "Card Number",
    expiration: "Expiration",
    cvv: "CVV",
  },
  team: {
    title: "Team Management",
    sub: "Invite team members and manage their access roles and permissions.",
    pageSub: "Members, roles, and invitations for your business workspace.",
    inviteMember: "Invite member",
    inviteBtn: "Invite",
    summaryTitle: "Summary",
    summarySub: "Your membership and team",
    yourRole: "Your role:",
    assignableRolesTitle: "Assignable roles",
    searchPlaceholder: "Name or email",
    allStatuses: "All statuses",
    emptyMembers: "No team members found",
    removeTitle: "Remove member",
    removeConfirm:
      "Are you sure you want to remove this member from your team?",
    roleOwner: "Owner",
    roleAdmin: "Administrator",
    roleDeveloper: "Developer",
    roleFinance: "Finance Manager",
    roleViewer: "Read Only",
  },
  developers: {
    title: "Developer Portal",
    sub: "API credentials, documentation, and real-time webhook endpoints.",
    pageTitle: "Applications",
    pageSub:
      "Management via your session (Bearer). Your servers use Basic application credentials, never this browser.",
    docsBtn: "API Documentation ↗",
    newAppBtn: "New application",
    emptyApps: "No applications",
    emptyAppsSub: "Create one to obtain credentials.",
    apiKeys: "API Keys",
    createKey: "Generate key",
    webhooks: "Webhooks",
    createWebhook: "Add endpoint",
    docsLink: "View interactive API reference",
  },
  merchantAssistant: {
    title: "Merchant assistant",
    subtitle:
      "An intelligent guide that understands your BizConnectPay workspace.",
    notReadyTitle: "Assistant is disabled",
    notReadyBody:
      "BizConnectPay has temporarily disabled the assistant. It will return to your dashboard when re-enabled.",
    privateKeyNote:
      "When external AI is disabled, answers come from the local knowledge base. AI credentials remain server-side.",
    consentTitle: "Allow the assistant to use your account context?",
    consentBody:
      "To answer questions and prepare reports, selected data may be processed locally. It is sent to an AI provider only if BizConnectPay enables external calls. Processing starts only after you agree.",
    consentData1: "Available and locked balances for active wallets.",
    consentData2:
      "Transaction totals by status, currency, and operation for the last 30 days.",
    consentData3:
      "Up to 12 recent transactions, without phone numbers or card details.",
    consentCheckbox:
      "I agree to let the assistant process this account context. My conversations and memory notes will be saved in my workspace and I can delete them.",
    enable: "Enable assistant",
    enableFailed: "Could not enable assistant",
    notReady: "Not configured",
    banner:
      "Ask about payments, wallets, and the operations that need your attention.",
    newChat: "New conversation",
    greeting: "Hello! I’m your BizConnectPay assistant.",
    greetingSub:
      "I can help explain your account information and find useful next steps.",
    quickActions: "Quick actions",
    quick: [
      "Summarize my recent payments and balances.",
      "Which recent transactions need my attention?",
      "Explain fees and settlement on my account.",
    ],
    inputPlaceholder: "Continue the conversation…",
    send: "Send",
    disclaimer:
      "The assistant can make mistakes. Verify important details in your dashboard.",
    thinking: "Checking your authorized account context…",
    replyFailed: "The assistant could not reply",
    loadFailed: "Could not load this conversation",
    memories: "Assistant memories",
    memoriesCount: "{count} saved note(s)",
    hide: "Hide",
    manage: "Manage",
    memoryDescription:
      "Add preferences or work context that the assistant can use in future replies.",
    memoryLabel: "Memory note",
    memoryPlaceholder: "e.g. I prefer weekly reports in English.",
    saveMemory: "Save note",
    memorySaved: "Note saved",
    memoryFailed: "Could not update this note",
    deleteMemory: "Delete note",
    noMemories: "No saved notes yet.",
    privacyNote:
      "Conversations and memories are private to your user and merchant account. The assistant cannot perform financial actions.",
    contextFreshness: "Financial data is read on the server for each question.",
    realtimeConnected: "Secure real-time chat is connected.",
    realtimeConnecting: "Connecting to secure real-time chat…",
    connectionLost: "Real-time connection lost. Reconnect and try again.",
    consentRequired: "Your consent is required to use this data.",
    deleteConversation: "Delete conversation",
    scheduledWork: "Scheduled reports",
    scheduledWorkSub:
      "The assistant prepares read-only insights while you are away.",
    jobTemplate: "Report type",
    templates: {
      DAILY_PAYMENT_DIGEST: "Daily payment summary",
      WEEKLY_ACCOUNT_HEALTH: "Weekly account health",
      PENDING_PAYMENT_REVIEW: "Pending operation review",
    },
    daily: "Daily",
    weekly: "Weekly",
    scheduleReport: "Schedule report",
    jobCreated: "Report scheduled",
    jobQueued: "Report added to the processing queue",
    jobFailed: "Could not manage this report",
    nextRun: "Next run",
    paused: "Paused",
    enabled: "Active",
    runNow: "Run now",
    viewReports: "View reports",
    deleteJob: "Delete",
    confirmDeleteJob: "Delete this scheduled report and its history?",
    noScheduledWork: "No scheduled reports.",
    noReports: "No reports available yet.",
    runStatus: {
      QUEUED: "Queued",
      RUNNING: "Running",
      COMPLETED: "Complete",
      FAILED: "Failed",
      SKIPPED: "Skipped",
    },
    scheduledWorkPrivacy:
      "Scheduled reports are read-only. They cannot send or approve payments or refunds.",
  },
  support: {
    title: "Merchant support",
    subtitle: "Chat with the BizConnectPay team and track your requests.",
    adminTitle: "Support center",
    adminSubtitle:
      "Work tickets, route them to the right teams, and communicate with merchants.",
    ticketList: "Support requests",
    live: "Live chat",
    connecting: "Connecting…",
    search: "Search requests",
    allStatuses: "All statuses",
    empty: "No support requests yet.",
    newTicket: "New request",
    subject: "Subject",
    category: "Category",
    message: "Describe your request",
    create: "Create request",
    created: "Request created",
    createFailed: "Could not create the request",
    loadFailed: "Could not load support requests",
    updateFailed: "Could not update the request",
    connectionFailed: "Could not open secure chat",
    replyFailed: "Could not send the message",
    replyPlaceholder: "Write a message…",
    send: "Send",
    admin: "BizConnectPay support",
    merchant: "Merchant",
    system: "System",
    internalNote: "Internal note",
    noAccess: "Your role cannot manage support requests.",
    selectTitle: "Select a request",
    selectBody: "Choose a conversation or create a new support request.",
    adminEmpty: "Requests assigned to your queue will appear here.",
    secureChat: "Messages are saved in the ticket history.",
    status: {
      OPEN: "Open",
      IN_PROGRESS: "In progress",
      WAITING_MERCHANT: "Waiting for merchant",
      RESOLVED: "Resolved",
      CLOSED: "Closed",
    },
    categories: {
      GENERAL: "General",
      PAYMENT: "Payment",
      PAYOUT: "Payout",
      REFUND: "Refund",
      BILLING: "Billing",
      TECHNICAL: "Technical",
      API: "API",
      WEBHOOK: "Webhook",
      ACCOUNT: "Account",
      VERIFICATION: "Verification",
      COMPLIANCE: "Compliance",
      RISK: "Risk",
      SECURITY: "Security",
    },
  },
  notifications: {
    title: "Notifications",
    sub: "Manage notification plans, email/SMS alerts, and connect your WhatsApp account for two-factor authentication (2FA).",
    preferences: "Preferences",
    refresh: "Refresh",
    allStatuses: "All",
    unread: "Unread",
    read: "Read",
    allTypes: "All types",
    emptyNotices: "No notifications",
    emptySub: "Nothing to report for these filters.",
    markAllRead: "Mark all as read",
    notificationDetails: "Details",
    loadingTitle: "Loading",
    tabPlans: "Plans & Tiers",
    tabTemplates: "Customer Templates",
    tabWhatsApp: "WhatsApp Connection",
    tabHistory: "Inbox & Messages",
    templatesTitle: "Customer notification templates",
    templatesSub:
      "Create custom templates for notifications sent by your API integration. Recipients will see your brand and content.",
    addTemplate: "New template",
    templateEmpty: "No custom templates",
    templateEmptySub:
      "Create a template, then send its code and variables with the notifications API.",
    editTemplate: "Edit template",
    templateCode: "Template code",
    templateChannel: "Channel",
    templateLanguage: "Language",
    templateSubject: "Subject (email)",
    templateBody: "Message",
    templateBrand: "Displayed brand name",
    templateActive: "Active template",
    templateDisabled: "Disabled template",
    templateBodyHelp:
      "Add variables using {{variable_name}} syntax, then provide them with each API send request.",
    saveTemplate: "Save",
    cancelTemplate: "Cancel",
    deleteTemplate: "Delete",
    confirmDeleteTemplate: "Delete this template?",
    templateEmail: "Email",
    templateSms: "SMS",
    templateWhatsApp: "WhatsApp",
    activePlan: "Current Plan",
    subscribedTo: "You are subscribed to the {plan} plan",
    noActiveSubscription: "No active subscription",
    noActiveSubscriptionDesc:
      "Subscribe to a notification plan to send automated SMS and WhatsApp alerts to your customers.",
    expiresOn: "Expires on {date}",
    autoRenewEnabled: "Automatic renewal enabled",
    autoRenewDisabled: "Automatic renewal disabled",
    enableAutoRenew: "Enable auto-renew",
    disableAutoRenew: "Disable auto-renew",
    cancelSubscription: "Cancel subscription",
    todayUsage: "Today's Consumption",
    totalNotificationsSent: "Total notifications sent today",
    whatsAppSent: "WhatsApp messages sent today",
    availablePlans: "Available Plans",
    subscribeBtn: "Subscribe to this plan",
    subscribeModalTitle: "Subscribe to {plan} plan",
    selectWallet: "Select wallet to debit",
    autoRenewCheckbox: "Enable automatic renewal at expiration (monthly)",
    confirmSubscribe: "Pay & Activate Plan",
    subscriptionSuccess: "Subscription activated successfully!",
    subscriptionCancelled: "Subscription cancelled successfully.",
    autoRenewUpdated: "Auto-renew setting updated.",
    channelsIncluded: "Channels included",
    maxDailyGlobal: "Total notifications / day",
    maxDailyWhatsApp: "WhatsApp messages / day",
    pricePerMonth: "{price} XAF / month",
    noWalletSelected: "Please select a wallet with sufficient balance.",
    insufficientFunds:
      "Insufficient funds in this wallet to pay for this plan.",
    whatsAppTitle: "WhatsApp Connection",
    whatsAppDesc:
      "Link your WhatsApp account to receive security alerts, transaction notifications, and two-factor authentication (2FA) codes.",
    whatsAppNoticeIndividual:
      "As an individual account, connecting WhatsApp allows you to receive and verify 2FA codes directly on your WhatsApp application.",
    statusConnected: "Connected",
    statusConnecting: "Connecting…",
    statusDisconnected: "Disconnected",
    statusQrReady: "QR Code ready to scan",
    statusPairingReady: "Pairing code generated",
    connectedNumber: "Connected Number",
    disconnectBtn: "Disconnect session",
    disconnectConfirm:
      "Are you sure you want to disconnect your WhatsApp session?",
    qrModeTab: "Scan QR Code",
    pairingModeTab: "Pairing Code",
    scanQrTitle: "Scan QR Code with WhatsApp",
    scanQrInstructions:
      "1. Open WhatsApp on your phone.\n2. Tap Settings / Menu > Linked Devices.\n3. Tap 'Link a Device' and point your camera at this code.",
    refreshQrBtn: "Refresh QR code",
    pairingTitle: "Link with Phone Number",
    pairingInstructions:
      "Enter your WhatsApp phone number in international format to receive an 8-character pairing code.",
    pairingPhonePlaceholder: "Ex: 699001122",
    generatePairingCode: "Generate Pairing Code",
    pairingCodeLabel: "Enter this code into WhatsApp:",
    enterPairingPrompt:
      "On your phone, open WhatsApp > Linked Devices > Link a Device > Link with phone number instead.",
    disconnectSuccess: "WhatsApp session disconnected.",
  },
  checkout: {
    paymentInfo: "Payment Information",
    country: "Country",
    selectCountry: "Select your country",
    operator: "Operator",
    selectOperator: "Select your operator",
    phone: "Phone number",
    phonePlaceholder: "Ex: 6XXXXXXXX",
    otpCode: "OTP code",
    otpPlaceholder: "Enter the code you received",
    otpHelp:
      "This payment method requires a verification code from your operator.",
    email: "Email address (optional receipt)",
    emailPlaceholder: "you@example.com",
    pay: "Pay",
    processing: "Processing…",
    simpleAndSecure: "Simple and secure payment",
    secure100: "100% secure payment",
    support247: "24/7 customer support",
    orderSummary: "Order Summary",
    paymentFor: "Payment for {merchant}",
    validUntil: "Valid until {date}",
    amount: "Amount",
    processingFee: "Processing fee",
    total: "Total",
    merchantAmountNotice: "Merchant amount: {amount} (automatically converted)",
    requestSent: "Payment request sent",
    validateOnPhone: "Now validate the transaction on your phone ({phone}).",
    reference: "Reference: {ref}",
    invalidLink: "Invalid payment link.",
    securedBy: "Secured by BizConnectPay",
  },
  locked: {
    title: "Restricted Module",
    desc: "This module requires full verification of your business file (KYB).",
    unlockAction: "Complete verification",
    businessOnlyTitle: "Module reserved for business accounts",
    businessOnlyDesc:
      "This module requires an active business workspace with approved KYB. Create your business workspace from the Accounts page, then complete its KYB case. Your individual account remains intact.",
    createBusinessBtn: "Create a business workspace",
    moduleWhat: "The {title} module",
    modules: {
      equipe: {
        title: "Team",
        desc: "Invite members, assign roles (FINANCE, DEVELOPER…), and manage access.",
      },
      developpeurs: {
        title: "Developers",
        desc: "Applications, API credentials, IP whitelisting, webhooks, and Sandbox / Live switch.",
      },
      liens: {
        title: "Payment Links",
        desc: "Create shareable payment links with amount, currency, expiration, and usage limits.",
      },
    },
  },
  notFound: {
    title: "404 · Page Not Found",
    sub: "The page you are looking for does not exist or has been moved.",
    backHome: "Back to Dashboard",
  },
};
